import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";

import styles from "./LastWorkPlace.module.scss";

interface LastWorkPlaceProps {
  companyName?: string | null;
  position?: string | null;
  period?: string | null;
  schedules?: string[] | string | null;
}

export const LastWorkPlace = ({
  companyName,
  position,
  period,
  schedules,
}: LastWorkPlaceProps) => {
  const scheduleList = Array.isArray(schedules)
    ? schedules
    : schedules
      ? [schedules]
      : [];

  return (
    <div className={styles.lastWorkPlace}>
      <div className={styles.title}>
        <div className={styles.titleIcon}>
          <WorkOutlineOutlinedIcon fontSize="small" sx={{ color: "#00C195" }} />
        </div>
        <div>Последнее место работы</div>
      </div>

      <div className={styles.content}>
        <div className={styles.item}>
          <div className={styles.label}>Название компании:</div>
          <div>{companyName || "-"}</div>
        </div>

        <div className={styles.item}>
          <div className={styles.label}>Должность:</div>
          <div>{position || "-"}</div>
        </div>

        <div className={styles.item}>
          <div className={styles.label}>Период работы:</div>
          <div>{period || "-"}</div>
        </div>

        <div className={styles.item}>
          <div className={styles.label}>График работы:</div>

          {scheduleList.length ? (
            <div>
              {scheduleList.map((schedule) => (
                <div key={schedule}>{schedule}</div>
              ))}
            </div>
          ) : (
            <div>-</div>
          )}
        </div>
      </div>
    </div>
  );
};